export const PATH = {
  DASHBOARD: '/dashboard',
  ANALYTICS: '/analytics',
  SHIPMENT: '/shipments',
  SHIPMENT_DETAIL: '/shipments/:id',
  TRACKING_LOGS: '/shipments/tracking-logs',
  REVIEW_TABLE: '/review-table',
  TRACKING_PAGE: '/tracking-page',
  TRACKING_CONFIGURATION_PAGE: '/tracking-page/configuration',
  TRANSIT_TIME: '/tracking-page/transit-time-editor',
  TRANSIT_TIME_DETAIL: '/tracking-page/transit-time-editor/:id',
  NOTIFICATIONS: '/notification-v2',
  NOTIFICATIONS_EMAIL: '/notification-v2/email',
  EMAIL_TEMPLATE: '/notification-v2/email/:status',
  SENDER_EMAIL: '/notification-v2/sender-email',
  RECIPIENT_EMAIL: '/notification-v2/recipient-email',
  POST_PURCHASE_EDD: '/tracking-page/post-purchase-edd',
  PRE_PURCHASE_EDD: '/tracking-page/pre-purchase-edd',
  BLACKLIST: '/tracking-page/blacklist',
  PLAN: '/plan',
  PLAN_BUNDLE: '/plan/bundle',
  SETTINGS: '/settings',
  WELCOME: '/welcome',
  FEEDBACK: '/feedback',
  LANGUAGES: '/tracking-page/languages',
  LANGUAGE_EDITOR: '/tracking-page/languages/:language',
};

export const embeddedNavLinksWithoutReview = [
  {
    label: 'Analytics',
    destination: PATH.ANALYTICS,
  },
  {
    label: 'Shipments',
    destination: PATH.SHIPMENT,
  },
  {
    label: 'Tracking Page',
    destination: PATH.TRACKING_PAGE,
  },

  {
    label: 'Notifications & Alerts',
    destination: PATH.NOTIFICATIONS,
  },
  {
    label: 'Settings',
    destination: PATH.SETTINGS,
  },
  {
    label: 'Feedbacks',
    destination: PATH.FEEDBACK,
  },
  {
    label: 'Subscription Plans',
    destination: PATH.PLAN,
  },
];

// export const embeddedNavLinks = [
//   ...embeddedNavLinksWithoutReview,
//   {
//     label: 'Review Table',
//     destination: PATH.REVIEW_TABLE,
//   },
// ];
